
import { useState, useEffect } from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

export default function Revenue({ supabase }) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadRevenue(); }, []);

  async function loadRevenue() {
    const { data } = await supabase.from("orders").select("total_amount, delivery_fee, payment_method, status, created_at").eq("status", "delivered");
    if (data) setOrders(data);
    setLoading(false);
  }

  const totalRevenue = orders.reduce((sum, o) => sum + (o.total_amount || 0), 0);
  const totalDeliveryFees = orders.reduce((sum, o) => sum + (o.delivery_fee || 0), 0);
  const totalOrders = orders.length;
  const avgOrderValue = totalOrders > 0 ? totalRevenue / totalOrders : 0;

  const paymentData = [
    { name: "Mobile Money", value: orders.filter(o => o.payment_method === "mobile_money").length, color: "#00A651" },
    { name: "Wallet", value: orders.filter(o => o.payment_method === "wallet").length, color: "#0057A8" },
    { name: "Cash", value: orders.filter(o => o.payment_method === "cash").length, color: "#f39c12" },
  ];

  if (loading) return <div style={{ color: "#666", textAlign: "center", padding: 40 }}>Loading revenue data...</div>;

  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16, marginBottom: 24 }}>
        {[
          { label: "Total Revenue", value: "Le " + totalRevenue.toLocaleString(), color: "#00A651", icon: "💰" },
          { label: "Delivery Fees", value: "Le " + totalDeliveryFees.toLocaleString(), color: "#0057A8", icon: "🚚" },
          { label: "Completed Orders", value: totalOrders, color: "#27ae60", icon: "✅" },
          { label: "Avg Order Value", value: "Le " + Math.round(avgOrderValue).toLocaleString(), color: "#f39c12", icon: "📊" },
        ].map(s => (
          <div key={s.label} style={{ background: "#111", border: "1px solid #222", borderRadius: 12, padding: 20, textAlign: "center" }}>
            <span style={{ fontSize: 28 }}>{s.icon}</span>
            <div style={{ color: s.color, fontSize: 24, fontWeight: "bold", marginTop: 8 }}>{s.value}</div>
            <div style={{ color: "#666", fontSize: 13, marginTop: 4 }}>{s.label}</div>
          </div>
        ))}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
        <div style={{ background: "#111", border: "1px solid #222", borderRadius: 12, padding: 20 }}>
          <h3 style={{ color: "#fff", fontSize: 15, fontWeight: "600", margin: "0 0 16px 0" }}>Payment Methods</h3>
          {totalOrders === 0 ? <div style={{ color: "#666", textAlign: "center", padding: 40 }}>No completed orders yet</div> : (
            <ResponsiveContainer width="100%" height={220}>
              <PieChart>
                <Pie data={paymentData} cx="50%" cy="50%" outerRadius={80} dataKey="value" label={({ name, value }) => value > 0 ? name + ": " + value : ""}>
                  {paymentData.map((entry, index) => <Cell key={index} fill={entry.color} />)}
                </Pie>
                <Tooltip contentStyle={{ background: "#1a1a1a", border: "1px solid #333", color: "#fff" }} />
              </PieChart>
            </ResponsiveContainer>
          )}
        </div>
        <div style={{ background: "#111", border: "1px solid #222", borderRadius: 12, padding: 20 }}>
          <h3 style={{ color: "#fff", fontSize: 15, fontWeight: "600", margin: "0 0 16px 0" }}>Revenue Summary</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            {[
              { label: "Delivery Fees (Platform Revenue)", value: "Le " + totalDeliveryFees.toLocaleString(), color: "#00A651" },
              { label: "Total GMV", value: "Le " + totalRevenue.toLocaleString(), color: "#0057A8" },
              { label: "Completed Deliveries", value: totalOrders, color: "#f39c12" },
              { label: "Average Order Value", value: "Le " + Math.round(avgOrderValue).toLocaleString(), color: "#9b59b6" },
            ].map(item => (
              <div key={item.label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: "1px solid #1a1a1a" }}>
                <span style={{ color: "#999", fontSize: 14 }}>{item.label}</span>
                <span style={{ color: item.color, fontWeight: "bold", fontSize: 16 }}>{item.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
